import React from 'react';

import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import useSearchParams from '@swf/core/hooks/useSearchParams';

import styles from './CasinoRewardInfo.scss';

interface CasinoRewardInfoParams {
  title: string;
  message: string;
}

const CasinoRewardInfo: React.FC = () => {
  const { title, message } = useSearchParams<CasinoRewardInfoParams>();

  return (
    <>
      <Header>
        {title}
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <p>{message}</p>
      </Body>
    </>
  );
};
export default CasinoRewardInfo;
